<template>
  <div id="app">
    <div style="position: fixed; top: 50px; width: 100%; z-index: 99999"></div>
    <header class="topbar">
      <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <div class="navbar-header">
          <a class="navbar-brand" href="/#/search-rides/">
            <b>
              <img
                src="./assets/wingz-logo-dark.svg"
                alt="homepage"
                class="dark-logo"
                height="30px"
              />
              <img
                src="./assets/wingz-logo-dark.svg"
                class="light-logo"
                alt="homepage"
                height="30px"
              />
            </b>
            <span>
              <img
                src="./assets/Wingz_Enterprise_Logo-2-black.svg"
                alt="homepage"
                class="dark-logo"
                width="100%"
                style="padding-right: 15px;"
              />
              <img
                src="./assets/Wingz_Enterprise_Logo-2-black.svg"
                alt="homepage"
                class="light-logo"
                width="100%"
                style="padding-right: 15px;"
              />
            </span>
          </a>
        </div>
        <div class="navbar-collapse">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a
                class="
                  nav-link nav-toggler
                  hidden-md-up
                  waves-effect waves-dark
                "
                href="javascript:void(0)"
                ><i class="ti-menu"></i
              ></a>
            </li>
            <li class="nav-item">
              <a
                class="
                  nav-link
                  sidebartoggler
                  hidden-sm-down
                  waves-effect waves-dark
                "
                href="javascript:void(0)"
                ><i class="ti-menu"></i
              ></a>
            </li>
          </ul>
          <ul
            v-if="this.getUser('username') != null"
            class="navbar-nav my-lg-0"
          >
            <li class="nav-item">
              <a
                class="nav-link dropdown-toggle waves-effect waves-dark"
                href=""
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <img
                  v-if="this.getUser()['id_profile_image'] != null"
                  v-bind:src="this.getUser()['id_profile_image'].url"
                  alt="user"
                  class="profile-pic"
                />
                <i
                  v-if="this.getUser()['id_profile_image'] == null"
                  class="fa fas fa-user-circle"
                  style="font-size: 2em; color: #455a64"
                ></i>
              </a>

              <div class="dropdown-menu dropdown-menu-right animated flipInY">
                <ul class="dropdown-user">
                  <li>
                    <div class="dw-user-box">
                      <div class="u-img">
                        <img
                          v-if="this.getUser().id_profile_image != null"
                          v-bind:src="this.getUser().id_profile_image.url"
                          alt="user"
                        />
                        <i
                          v-if="this.getUser().id_profile_image == null"
                          class="fa fas fa-user-circle"
                          style="font-size: 4em; color: #455a64"
                        ></i>
                      </div>
                      <div class="u-text">
                        <h4>{{ this.getUser().username }}</h4>
                        <p class="text-muted">{{ this.getUser().email }}</p>
                      </div>
                    </div>
                  </li>
                  <li role="separator" class="divider"></li>
                  <li>
                    <a @click="logout()"
                      ><i class="fa fa-power-off"></i> Logout</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <aside v-if="this.getUser('username') != null" class="left-sidebar">
      <!-- Sidebar scroll-->
      <div class="scroll-sidebar">
        <!-- Sidebar navigation-->
        <nav class="sidebar-nav">
          <ul id="sidebarnav">
            <li>
              <hr class="hr1" />
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/search-rides/"
              >
                <i class="mdi mdi-search-web"></i
                ><span class="hide-menu">Ride Search</span>
              </router-link>
            </li>

            <li class="nav-item">
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/current-rides/"
              >
                <i class="mdi mdi-car"></i
                ><span class="hide-menu">Current Rides</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/will-call-rides/"
              >
                <i class="mdi mdi-phone"></i
                ><span class="hide-menu">Will Call Rides</span>
              </router-link>
            </li>            
            <li
              v-if="
                getUser()['is_agent'] ||
                getUser()['is_admin'] ||
                getUser()['is_superuser']
              "
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/assign-rides/"
              >
                <i class="mdi mdi-account-switch"></i
                ><span class="hide-menu">Assign Rides</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/search-drivers/"
              >
                <i class="mdi mdi-account-search"></i
                ><span class="hide-menu">Driver Search</span>
              </router-link>
            </li>
            <!--<li class="nav-item">-->
            <!--<router-link class="nav-link waves-effect waves-dark" to="/drivers-map/">-->
            <!--<i class="mdi mdi-map"></i><span class="hide-menu">Drivers map</span>-->
            <!--</router-link>-->
            <!--</li>-->
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/driver-payments/"
              >
                <i class="mdi mdi-currency-usd"></i
                ><span class="hide-menu">Driver Payments</span>
              </router-link>
            </li>
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/payment-adjustments/"
              >
                <i class="mdi mdi-auto-fix"></i
                ><span class="hide-menu">Payment Adjustments</span>
              </router-link>
            </li>
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/missing-signatures/"
              >
                <i class="mdi mdi-pencil-lock"></i
                ><span class="hide-menu">Missing Signatures</span>
              </router-link>
            </li>
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/pending-payments/"
              >
                <i class="mdi mdi-av-timer"></i
                ><span class="hide-menu">Pending Payments</span>
              </router-link>
            </li>
            <li
              v-if="
                getUser()['is_admin'] ||
                getUser()['is_superuser'] ||
                getUser()['is_accounting']
              "
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/reports/"
              >
                <i class="mdi mdi-chart-bar"></i
                ><span class="hide-menu">Reports</span>
              </router-link>
            </li>
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/claims-processing/"
              >
                <i class="mdi mdi-verified"></i
                ><span class="hide-menu">Claims Processing</span>
              </router-link>
            </li>

            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/booking-organizations/"
              >
                <i class="mdi mdi-account-star"></i
                ><span class="hide-menu">Booking Orgs</span>
              </router-link>
            </li>

            <li>
              <hr class="hr1" />
            </li>
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/settings/"
              >
                <i class="mdi mdi-settings"></i
                ><span class="hide-menu">Settings</span>
              </router-link>
            </li>
            <li
              v-if="getUser()['is_admin'] || getUser()['is_superuser']"
              class="nav-item"
            >
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/request-logs/"
              >
                <i class="mdi mdi-heart-pulse"></i
                ><span class="hide-menu">System Status</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                class="nav-link waves-effect waves-dark"
                to="/report-emergency/"
              >
                <i class="mdi mdi-alert"></i
                ><span class="hide-menu">Report Emergency</span>
              </router-link>
            </li>

            <li>
              <hr class="hr1" />
            </li>
            <li class="nav-item text-nowrap nav-logout">
              <a @click="logout()" class="nav-link waves-effect waves-dark">
                <i class="mdi mdi-logout"></i
                ><span class="hide-menu"
                  >Logout ({{
                    this.getUser("username")
                      ? this.getUser("username")
                      : "Login"
                  }})</span
                >
              </a>
            </li>
          </ul>
        </nav>
        <!-- End Sidebar navigation -->
      </div>
      <!-- End Sidebar scroll-->
      <div class="sidebar-footer">
        <label>Version {{ version }}</label>
      </div>
    </aside>
    <div class="page-wrapper">
      <main role="main" class="main">
        <!-- <button class="right-side-toggle waves-effect waves-light btn-inverse btn btn-circle btn-sm pull-right m-l-10"><i class="ti-settings text-white"></i></button> -->
        <router-view />
      </main>
    </div>
    <!-- template for the modal component -->
    <script type="text/x-template" id="modal-template">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header">
                  default header
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  default body
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="$emit('close')">
                    OK
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </script>
  </div>
</template>

<script>
import Vue from "vue";

import axios from "axios";

// const router = new VueRouter({
//   mode: 'history'
// })

Vue.mixin({
  methods: {
    compareRides: function (otherArray) {
      return function (current) {
        return (
          otherArray.filter(function (other) {
            return other.id_ride == current.id_ride;
          }).length == 0
        );
      };
    },
    filterStatus: function (event) {
      this.data.filteredRides = [];
      for (var count in this.data.rides) {
        var ride = this.data.rides[count];
        var add = true;
        for (var count2 in this.data.filters.filters) {
          var filter = this.data.filters.filters[count2];
          var filterValue = document.getElementById(filter);
          if (!filterValue || filterValue == null) {
            continue;
          }
          filterValue = filterValue.value;
          switch (filter) {
            case "status-filter":
              var checkValue = ride.id_type_ride_status.code
                .replace(
                  ride.id_type_ride_status.code.charAt(0),
                  ride.id_type_ride_status.code.charAt(0).toUpperCase()
                )
                .replace("_", " ")
                .replace("_", " ")
                .replace("linear", "General")
                .replace("logarithmic", "Accelerated");
              if (
                filterValue != "All" &&
                checkValue != filterValue &&
                !filterValue.startsWith("Select")
              ) {
                add = false;
              }
              break;
            case "rider-filter":
              if (
                filterValue != "All" &&
                !filterValue.startsWith("Select") &&
                (
                  ride.id_rider.name_first +
                  " " +
                  ride.id_rider.name_last
                ).trim() != filterValue.trim()
              ) {
                add = false;
              }
              break;
            case "driver-filter":
              if (
                filterValue != "All" &&
                !filterValue.startsWith("Select") &&
                (
                  ride.id_driver.name_first +
                  " " +
                  ride.id_driver.name_last
                ).trim() != filterValue.trim()
              ) {
                add = false;
              }
              break;
            case "booking-filter":
              if (filterValue != "All" && !filterValue.startsWith("Select")) {
                if (
                  ride.id_business_provider == null ||
                  ride.id_business_provider.username.trim() !=
                    filterValue.trim()
                ) {
                  add = false;
                } else if (
                  ride.id_business_provider.name_first +
                    " " +
                    ride.id_business_provider.name_last ==
                  filterValue
                ) {
                  add = true;
                }
              }
              break;
            case "pickup-filter":
              if (
                filterValue != "All" &&
                !filterValue.startsWith("Select") &&
                ride.default_pickup_address.trim() != filterValue.trim()
              ) {
                add = false;
              }
              break;
            case "dropoff-filter":
              if (
                filterValue != "All" &&
                !filterValue.startsWith("Select") &&
                ride.default_dropoff_address.trim() != filterValue.trim()
              ) {
                add = false;
              }
              break;
          }
        }
        if (add) {
          this.data.filteredRides.push(ride);
        }
      }
      this.data.sortedRides = this.data.filteredRides.slice(0);
      this.totalRows = this.data.filteredRides.length;
    },
    sortResults: function (event) {
      this.isLoading = true;
      var trigger = event.target.innerText;
      if (
        this.data.filters.lastSorted &&
        this.data.filters.lastSorted != trigger
      ) {
        this.data.sortDirection = 0;
        document.getElementById(this.data.filters.lastSorted).style.visibility =
          "hidden";
      } else if (!this.data.filters.lastSorted) {
        this.data.sortDirection = 0;
      }
      this.data.sortDirection == 0
        ? (this.data.sortedRides.sort(this.compareAsc),
          (this.data.sortDirection = 1),
          (this.data.filters.lastSorted = event.target.innerText),
          (document.getElementById(trigger).style.transform = null),
          (document.getElementById(trigger).style.visibility = "visible"))
        : this.data.sortDirection == 1
        ? (this.data.sortedRides.sort(this.compareAsc).reverse(),
          (this.data.sortDirection = -1),
          (document.getElementById(trigger).style.visibility = "visible"),
          (document.getElementById(trigger).style.transform = "rotate(180deg)"))
        : (console.log("Reset sortedRides"),
          (this.data.sortedRides = this.data.filteredRides.slice(0)),
          (this.data.sortDirection = 0),
          (document.getElementById(trigger).style.visibility = "hidden"));
      this.isLoading = false;
    },
    compareAsc: function (a, b) {
      var comp1;
      var comp2;
      switch (event.target.innerText.toLowerCase()) {
        case "ride id":
          comp1 = a.id_ride;
          comp2 = b.id_ride;
          break;
        case "id":
          if (a.id_user && b.id_user) {
            comp1 = a.id_user;
            comp2 = b.id_user;
          } else if (a.id_user && !b.id_user) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "status":
          if (a.id_type_ride_status && b.id_type_ride_status) {
            comp1 = a.id_type_ride_status.code;
            comp2 = b.id_type_ride_status.code;
          } else if (a.id_type_ride_status && !b.id_type_ride_status) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "email":
          if (a.email && b.email) {
            comp1 = a.email;
            comp2 = b.email;
          } else if (a.email && !b.email) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "market":
          if (a.id_driver.id_market.code && b.id_driver.id_market.code) {
            comp1 = a.id_driver.id_market.code;
            comp2 = b.id_driver.id_market.code;
          } else if (
            a.id_driver.id_market.code &&
            !b.id_driver.id_market.code
          ) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "driver type":
          console.log("driver type");
          if (
            a.id_driver.id_type_driver_account.code &&
            b.id_driver.id_type_driver_account.code
          ) {
            comp1 = a.id_driver.id_type_driver_account.code;
            comp2 = b.id_driver.id_type_driver_account.code;
          } else if (
            a.id_driver.id_type_driver_account.code &&
            !b.id_driver.id_type_driver_account.code
          ) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "rider":
          if (a.id_rider && b.id_rider) {
            comp1 = a.id_rider.name_first;
            comp2 = b.id_rider.name_first;
          } else if (a.id_rider && !b.id_rider) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "driver":
          if (a.id_driver && b.id_driver) {
            comp1 = a.id_driver.name_first;
            comp2 = b.id_driver.name_first;
          } else if (a.id_driver && !b.id_driver) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "first name":
          if (a.name_first && b.name_first) {
            comp1 = a.name_first;
            comp2 = b.name_first;
          } else if (a.name_first && !b.name_first) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "last name":
          if (a.name_last && b.name_last) {
            comp1 = a.name_last;
            comp2 = b.name_last;
          } else if (a.name_last && !b.name_last) {
            return 1;
          } else {
            return -1;
          }
          break;
        case "app version":
          comp1 = a.app_info.app_version ? a.app_info.app_version : "2.1.0";
          comp2 = b.app_info.app_version ? b.app_info.app_version : "2.1.0";
          break;
        case "app platform":
          comp1 = a.app_info.app_platform ? a.app_info.app_platform : "N/A";
          comp2 = b.app_info.app_platform ? b.app_info.app_platform : "N/A";
          break;
        case "vehicle":
          comp1 = a.vehicles
            ? a.vehicles[0]
              ? a.vehicles[0].model
              : "N/A"
            : "N/A";
          comp2 = b.vehicles
            ? b.vehicles[0]
              ? b.vehicles[0].model
              : "N/A"
            : "N/A";
          break;
        case "vehicle type":
          comp1 = a.vehicles
            ? a.vehicles[0]
              ? a.vehicles[0].id_type_vehicle.capacity
              : 0.1
            : 0.1;
          comp2 = b.vehicles
            ? b.vehicles[0]
              ? b.vehicles[0].id_type_vehicle.capacity
              : 0.1
            : 0.1;
          break;
        case "pick-up date":
          comp1 = a.date_pickup;
          comp2 = b.date_pickup;
          break;
        case "from":
          comp1 = a.default_pickup_address;
          comp2 = b.default_pickup_address;
          break;
        case "to":
          comp1 = a.default_dropoff_address;
          comp2 = b.default_dropoff_address;
          break;
        case "booking origin":
          if (a.id_business_provider && b.id_business_provider) {
            comp1 = a.id_business_provider.username;
            comp2 = b.id_business_provider.username;
          } else if (a.id_business_provider && !b.id_business_provider) {
            return -1;
          } else {
            return 1;
          }
          break;
        case "date":
          if (a.date_transaction && b.date_transaction) {
            comp1 = a.date_transaction;
            comp2 = b.date_transaction;
          }
      }
      return !comp1 || !comp2 ? -1 : comp1 < comp2 ? -1 : comp1 > comp2 ? 1 : 0;
    },
  },
});
$(function () {
  $(".left-sidebar #sidebarnav li").click(function () {
    $(".left-sidebar #sidebarnav li").each(function (index) {
      $(this).removeClass("active");
    });
    var url = window.location;

    var element = $("ul#sidebarnav a")
      .filter(function () {
        return this.href == url;
      })
      .addClass("active")
      .parent()
      .addClass("active");
    while (true) {
      if (element.is("li")) {
        element = element.parent().addClass("in").parent().addClass("active");
      } else {
        break;
      }
    }
  });
});

export default {
  name: "App",

  methods: {
    logout: function () {
      console.log("logout");

      Vue.prototype.$http.defaults.headers.common["Authorization"] = null;

      localStorage.setItem("user", null);
      $("body").addClass("logged-out");

      window.location.reload(true);
    },
  },
  computed: {
    version: function () {
      if (process.env.version) {
        return process.env.version;
      }
    },
  },
};
</script>

<style>
/*#app {*/
/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*-webkit-font-smoothing: antialiased;*/
/*-moz-osx-font-smoothing: grayscale;*/
/*text-align: center;*/
/*color: #2c3e50;*/
/*}*/

/* body {
    margin: 0;
    font-family: "Lucida Grande", "Verdana", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
    font-size: .875rem;
  } */

a:hover {
  color: darkgray;
}

/*#sidebar {*/
/*width: 15%;*/
/*!*padding: 0 10px;*!*/
/*float: left;*/
/*border-right: solid gray 1px;*/
/*height: 100%;*/
/*position: fixed;*/
/*}*/

.p-0 {
  padding: 0 !important;
}

.nav {
  height: 100%;
  margin-top: 15px;
}

/*.navbar {*/
/*position: relative;*/
/*display: flex;*/
/*flex-wrap: wrap;*/
/*align-items: center;*/
/*justify-content: space-between;*/
/*padding: 0.5rem 1rem;*/
/*}*/

/*.navbar-brand {*/
/*padding-top: .75rem;*/
/*padding-bottom: .75rem;*/
/*font-size: 1rem;*/
/*#background-color: rgba(0,0,0,0.25);*/
/*box-shadow: inset -1px 0 0 rgba(0,0,0,0.25);*/
/*background: #3352FF;*/
/*}*/

.nav-link {
  font-weight: 500;
  color: white;
  display: block;
  padding: 0.5rem 1rem;
}

.sidebar-nav #sidebarnav .nav-logout,
.mini-sidebar .sidebar-nav #sidebarnav .nav-logout {
  position: absolute;
  bottom: 10px;
  display: none;
}

/*.sticky-top {*/
/*position: -webkit-sticky;*/
/*position: sticky;*/
/*top: 0;*/
/*z-index: 1020;*/
/*}*/

.container-fluid {
  width: 100%;
  /* padding-right: 15px;
    padding-left: 15px; */
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.text-primary {
  color: #000 !important;
}

.main {
  margin-top: 30px;
}

hr.hr1 {
  width: 100%;
  border: 0.5px solid transparent;
}

/*
  .result-label {
    border: none !important;
  } */

/* .result-item {
    border-top: none !important;
    padding: 0.5rem !important;
  } */

/* .form-control {
    border: none;
    border-left: 1px solid;
    border-radius: 1px;
    margin: 5px;
  } */

.form-ddown {
  margin-right: 15px !important;
}
/*
  .ddown {
    border: 1px solid !important;
  } */

.search-label {
  /* font-size: 8pt; */
  display: block;
  font-weight: 500;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  /*width: 30%;*/
  height: 30%;
  background-color: rgba(0, 0, 0, 0.5);

  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  height: 100%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  border: none;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  /*margin: 20px 0;*/
}

.model-footer {
  border: none;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.topbar .top-navbar .navbar-header .navbar-brand b {
  display: none;
}

.mini-sidebar .topbar .top-navbar .navbar-header .navbar-brand b {
  display: inline;
}
.form-material {
  padding: 10px;
}
.modal-body .form-material {
  padding: 0px;
}
.breadcrumb {
  display: none;
}
html body h3.text-themecolor {
  color: #212529;
}

.toasted.bubble {
  background-color: red !important;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;

  border-top: 5px solid #212529;
}
.logged-out .left-sidebar {
  display: none;
}
.navbar-brand {
  float: left;
  margin-left: 2px;
}

.mini-sidebar .navbar-brand {
  float: none;
  margin-left: initial;
}
.vdatetime-calendar__month {
  min-height: 315px;
}
.nowrap {
  white-space: nowrap;
}

.multiselect__tag {
  background: #398bf7 !important;
}

.multiselect__option--highlight {
  background: #398bf7 !important;
}
.multiselect__content-wrapper {
  overflow: inherit !important;
}

/* Checkbox CSS */
.checkbox-wrapper {
  max-width: 485px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  background-color: #fff;
}
.checkbox-wrap {
  padding: 50px;
}
.filter-head {
  margin-bottom: 20px;
}
.filter-txt {
  display: block;
  color: #4d4d4d;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
}
.discoverred-txt {
  color: #a3a3a3;
  font-size: 16px;
}
.checkbox-item {
}
.checkbox-list {
  display: inline-flex;
  flex-wrap: wrap;
}
.checkbox-list li {
}

/*Checkboxes styles*/
.checkbox-list input[type="checkbox"] {
  display: none;
}

.checkbox-list input[type="checkbox"] + label {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #808080;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  margin-bottom: 12px;
  margin-right: 15px;
  height: 36px;
  border: 1px solid #e5e5e5;
  padding: 5px 10px;
  border-radius: 12px;
}
.checkbox-list input[type="checkbox"] + label:before {
  content: "";
  display: block;
  height: 15px;
  border: 2px solid #06f;
  display: none;
  width: 8px;
  margin-right: 20px;
  transform: rotate(45deg);
  border-top-color: transparent;
  border-left-color: transparent;
  transition: all 0.12s;
  position: static;
  margin-top: -2px;
}

.checkbox-list input[type="checkbox"]:checked + label {
  color: #06f;
  border-color: #06f;
}
.checkbox-list input[type="checkbox"]:checked + label:before {
  opacity: 1;
  display: inline-block;
}
.checkbox-list li.select-all {
  border: none;
  padding: 0;
  width: 100%;
}
.checkbox-list .select-all label {
  background-color: #f1f1f1;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
}
li {
  list-style: none;
}
.checkbox-item * {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.checkbox-item * {
  margin: 0;
  padding: 0;
}

.sidebar-footer {
  padding-left: 45px;
  font-size: 13px;
  padding-right: 35px;
  position: relative;
  padding-top: 20px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue